export const CheckoutSource = {
  Shopify: 'shopify',
  ShopifySbu: 'shopify_sbu',
};
